export default {
    update: function (eventId, slots) {
        return {type: 'UPDATE_MY_AVAILABILITY', eventId, slots};
    },
    block: function (eventId, start, end) {
        return {type: 'BLOCK_AVAILABILITY_SLOT', eventId, start, end};
    },
    unblock: function (eventId, start, end) {
        return {type: 'UNBLOCK_AVAILABILITY_SLOT', eventId, start, end};
    }
};
